/*
* @Description:
* @LastEditors: wjx
* @Date: 2019-01-15 17:21:38
*/
import Vue from "vue";
import router from "./index";
import store from "../store/index";
import querystring from 'vux/src/tools/querystring/index.js'

import wxShareInfo from "@/public/wxShare"; 
import { userGuide } from "@/public/userGuide.js";
import {
getUsersData,
klnPublicJump,
clearExpireSession,
reportLogin,
} from "@/api/ajax";
import api from "@/api/index";
import config from "@/config/index.js";
const Api = new api();
export default () => {
/*
* storage 注意事项  ${store} url回跳地址 from 来源类型
*                 ${vueRouterBackPage} 页面内的重定向
* */

let watchStorageHasToGoPage = () => {
let urls = location.href;
if (sessionStorage.routerBackPageForAnswer) {
function goBackFunc() {
let page2 = sessionStorage.routerBackPageForAnswer;
sessionStorage.removeItem("routerBackPageForAnswer");
location.href = page2;
}
if (/share|home/.test(urls)) {


}
}
return true;
};
watchStorageHasToGoPage();

router.beforeEach((to, from, next) => {
/*
* 通用分享
*
* */
if (!/share|correct/.test(to.path)) {
let shareUrl = `${config.javaPath}/html/answerGold/index210505.html#/home?shareFlag=true`;

wxShareInfo(
"医术高超的同仁才敢玩：答题拼图",
"答对100%中奖！",
"http://cdn.yxvzb.com/html/AnswerGold/share1.png",
location.href.split("#")[0],
shareUrl,
""
);
}

if (to.matched.length === 0) {
next({ name: "home" });
}
store.dispatch("change", true); 



userGuide(store, to, next);




});

router.afterEach((to, from) => {

let env = config.env == "doc" ? "资料库-" : "";
Vue.prototype.$sa.registerPage({
platform: "wx",
operation_tm: new Date().getTime(),

frompage_name:
to.query.isTemp ||
(to.query.shequn
? 6
: to.query.shareFlag
? "分享"
: to.query.visiterId
? "课代表邀请"
: from.meta.pageName || ""),
frompage_url: from.fullPath || "",
currentpage_name: env + to.meta.pageName,
currentpage_url: to.fullPath,



});

Vue.prototype.$sa.re_pageview();
setTimeout(() => {
store.dispatch("change", false);
}, 500);
});
};



// WEBPACK FOOTER //
// ./src/router/guide.js